import React from 'react'
import PropTypes from 'prop-types';

import {extractIndividualErrors} from 'validation'
import BaseComponent from 'common/BaseComponent'
import theme from 'theme/theme.scss'
import ErrorTooltip from 'common/ErrorTooltip'
import {getMessage as msg} from 'MessageBundle'

export default class Select extends BaseComponent {

    focus = () => {
        this.select.focus();
    };

    render() {
        const errorMessages = extractIndividualErrors(this.props.errorMessages, this.props.name, this.props.index);
        const emptyValue = this.props.emptyValue !== undefined ? this.props.emptyValue : msg("common.emptyOption");
        return (
            <div className={this.props.className}>
                {this.props.label ? <label htmlFor={this.props.id}>{this.props.label}{this.props.required ? <span>*</span> : ""}</label> : ""}
                <select id={this.props.id} value={this.props.value} onChange={this.props.onChange} size={this.props.size}
                    className={errorMessages.length > 0 ? theme.errorField : ""} disabled={this.props.disabled}
                    ref={(select) => this.select = select} title={!this.props.showExclamationMark && errorMessages.length > 0 ? errorMessages.join("\n") : null}>
                    {this.props.allowEmpty ? <option value="">{emptyValue}</option> : null}
                    {Array.from(this.props.options).map((value, index) => {return (<option key={index} value={value[0]}>{value[1]}</option>)})}
                </select>
                {this.props.showExclamationMark && errorMessages.length > 0 ? <ErrorTooltip for={this.props.id} value={errorMessages}/> : ""}
            </div>
        )
    }
}

Select.propTypes = {
    id: PropTypes.string.isRequired,
    value: (props) => {
        if(props.value === undefined && props.emptyValue === undefined) {
            return new Error('One of props: value or emptyValue is required, but was not specified in ');
        }
        if(props.value !== undefined && typeof props.value !== 'string' && typeof props.value !== 'number') {
            return new Error('Invalid prop type for value prop in ');
        }
    },
    label: PropTypes.string,
    options: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    allowEmpty: PropTypes.bool,
    emptyValue: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    size: PropTypes.number
};

Select.defaultProps = {
    allowEmpty: true,
    showExclamationMark: true
};



// WEBPACK FOOTER //
// ./src/common/Select/index.js